export default function () {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.5269 4.84277H8.85111C8.18514 4.84277 7.56287 5.17426 7.19131 5.72694L4.33455 9.97638C3.83973 10.7124 3.88876 11.6864 4.455 12.3691L11.6577 21.0523C12.4392 21.9944 13.8761 22.0198 14.6903 21.1059L22.3875 12.4665C23.0314 11.7437 23.0653 10.6635 22.4679 9.90179L19.1006 5.60849C18.7214 5.12511 18.1412 4.84277 17.5269 4.84277Z"
                stroke="url(#paint0_linear_1135_467)"
            />
            <path
                d="M9.5 10.8428L12.668 15.5947C13.0638 16.1884 13.9362 16.1884 14.3321 15.5947L17.5 10.8428"
                stroke="url(#paint1_linear_1135_467)"
                strokeLinecap="round"
            />
            <defs>
                <linearGradient id="paint0_linear_1135_467" x1="22.0714" y1="4.46777" x2="17.8277" y2="15.5376" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F8D593" />
                    <stop offset="1" stopColor="#C6904E" />
                </linearGradient>
                <linearGradient id="paint1_linear_1135_467" x1="13.5" y1="11.5928" x2="13.5" y2="16.8428" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E7BD7C" />
                    <stop offset="1" stopColor="#C6904E" />
                </linearGradient>
            </defs>
        </svg>
    );
}
